import { render, staticRenderFns } from "./capitalChangeDetail.vue?vue&type=template&id=a9e073e6&scoped=true"
import script from "./capitalChangeDetail.vue?vue&type=script&lang=js"
export * from "./capitalChangeDetail.vue?vue&type=script&lang=js"
import style0 from "./capitalChangeDetail.vue?vue&type=style&index=0&id=a9e073e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e073e6",
  null
  
)

export default component.exports